module.exports = __webpack_public_path__ + "static/media/areamap10.88e31ec6.svg";